import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table";
import { useStyles } from "../styles";
import { CountUp } from "../../../components/CountUp";
import { ResultsOffer } from "../../../types/offers";
import { useCallback } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Login } from "@mui/icons-material";

type ListProps = {
  data: ResultsOffer[];
  loading?: boolean;
};

export function List({ data, loading }: ListProps) {
  const navigate = useNavigate();
  const styles = useStyles();

  const RenderDetailCampaign = useCallback(
    (item: ResultsOffer) => {
      return (
        <Tooltip title="Visualizar oferta" placement="top">
          <IconButton
            onClick={() =>
              navigate(`/results-offers/${item.id_oferta}`, {
                state: {
                  name: item.nome_oferta,
                },
              })
            }
          >
            <Login />
          </IconButton>
        </Tooltip>
      );
    },
    [navigate]
  );

  return (
    <>
      <Paper
        variant="outlined"
        elevation={0}
        className={styles.paperCreatedDay}
      >
        <Table
          isLoading={loading}
          toolbar={false}
          data={data}
          columns={[
            { title: "Nome", field: "nome_oferta" },
            {
              title: "Ticket médio",
              field: "ticket_medio",
              render: (row) => (
                <CountUp
                  start={0}
                  end={Number(row.ticket_medio) || 0}
                  prefix="R$ "
                  decimals={2}
                />
              ),
            },
            {
              title: "Investimento",
              field: "investimento",
              render: (row) => (
                <CountUp
                  start={0}
                  end={Number(row.investimento) || 0}
                  prefix="R$ "
                  decimals={2}
                />
              ),
            },
            {
              title: "Vendas",
              field: "qtde_vendas",
              render: (row) => (
                <CountUp start={0} end={Number(row.qtde_vendas) || 0} />
              ),
            },
            {
              title: "Faturamento",
              field: "faturamento",
              render: (row) => (
                <CountUp
                  start={0}
                  end={Number(row.faturamento) || 0}
                  prefix="R$ "
                  decimals={2}
                />
              ),
            },
            {
              title: "ROI",
              field: "roi",
              render: (row) => (
                <CountUp
                  start={0}
                  end={Number(row.roi) || 0}
                  prefix="R$ "
                  decimals={2}
                />
              ),
            },
            {
              title: "Margem",
              field: "margem",
              render: (row) => (
                <CountUp
                  start={0}
                  end={Number(row.margem) || 0}
                  suffix="%"
                  decimals={3}
                />
              ),
            },
            {
              title: "Ações",
              field: "margem",
              render: RenderDetailCampaign,
            },
          ]}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
          options={{
            actionsColumnIndex: -1,
            pageSize: 7,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
      </Paper>
    </>
  );
}
